# frozen_string_literal: true

module Engine
  module Game
    module G1846TwoPlayerVariant
    end
  end
end
